// src/App.js
import * as React from "react";
import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./component/sharedComponents/Loader.jsx";
import ProtectedRoute from "./component/sharedComponents/ProtectedRoute.jsx";

const DuckDiseases = React.lazy(() => import("./component/Diseases/DuckDiseases.jsx"));
const FishDiseases = React.lazy(() => import("./component/Diseases/FishDiseases.jsx"));
const LivestockDiseases = React.lazy(() => import("./component/Diseases/LivestockDiseases.jsx"));
const OtherBirdsDiseases = React.lazy(() => import("./component/Diseases/OtherBirdsDiseases.jsx"));
const PoultryDiseases = React.lazy(() => import("./component/Diseases/PoultryDiseases.jsx"));
const TurkeyDiseases = React.lazy(() => import("./component/Diseases/TurkeyDiseases.jsx"));
const VerifyOTP = React.lazy(() => import("./component/Forms/VerifyOTP.jsx"));
const DuckFarm = React.lazy(() => import("./component/posts/DuckFarm.jsx"));
const FishFarming = React.lazy(() => import("./component/posts/FishFarming.jsx"));
const OtherFarming = React.lazy(() => import("./component/posts/OtherFarming.jsx"));
const PoultryFarming = React.lazy(() => import("./component/posts/PoultryFarming.jsx"));
const TurkeyFarming = React.lazy(() => import("./component/posts/TurkeyFarming.jsx"));
const AddCompany = React.lazy(() => import("./component/sharedComponents/AddCompany.jsx"));
const AuthCallback = React.lazy(() => import("./component/sharedComponents/AuthCallback.jsx"));
const AboutUsPage = React.lazy(() => import("./pages/AboutUsPage.jsx"));
const AddGps = React.lazy(() => import("./pages/AddGps.jsx"));
const AddProductPage = React.lazy(() => import("./pages/AddProductPage.jsx"));
const AdvertisingRequest = React.lazy(() => import("./pages/AdvertisingRequest.jsx"));
const AgricultureNews = React.lazy(() => import("./pages/AgricultureNews.jsx"));
const AnimalFarming = React.lazy(() => import("./pages/AnimalFarming.jsx"));
const AnimalHealthMarket = React.lazy(() => import("./pages/AnimalHealthMarket.jsx"));
const ApplynowPage = React.lazy(() => import("./pages/ApplynowPage.jsx"));
const Banks = React.lazy(() => import("./pages/Banks.jsx"));
const BetweenPeople = React.lazy(() => import("./pages/BetweenPeople.jsx"));
const CharacterPage = React.lazy(() => import("./pages/CharacterPage.jsx"));
const ChickCompaniesPage = React.lazy(() => import("./pages/ChickCompaniesPage.jsx"));
const CitiesGovernorates = React.lazy(() => import("./pages/CitiesGovernorates.jsx"));
const ClearanceShipmentsPage = React.lazy(() => import("./pages/ClearanceShipmentsPage.jsx"));
const CommodityExchangepage = React.lazy(() => import("./pages/CommodityExchangepage.jsx"));
const CompanyDirectory = React.lazy(() => import("./pages/CompanyDirectory.jsx"));
const CompanyGpsPage = React.lazy(() => import("./pages/CompanyGpsPage.jsx"));
const CompanyPage = React.lazy(() => import("./pages/CompanyPage.jsx"));
const CompanyProductPrices = React.lazy(() => import("./pages/CompanyProductPrices.jsx"));
const ContactUs = React.lazy(() => import("./pages/ContactUs.jsx"));
const CornshipmentsPage = React.lazy(() => import("./pages/CornshipmentsPage.jsx"));
const CreateJobpage = React.lazy(() => import("./pages/CreateJobpage.jsx"));
const DailyEggDistributorsPage = React.lazy(() => import("./pages/DailyEggDistributorsPage.jsx"));
const DailyEggPricePage = React.lazy(() => import("./pages/DailyEggPricePage.jsx"));
const DairyCowFeed = React.lazy(() => import("./pages/DairyCowFeed.jsx"));
const DuckFeedPage = React.lazy(() => import("./pages/DuckFeedPage.jsx"));
const EconmicNews = React.lazy(() => import("./pages/EconmicNews.jsx"));
const EgyptianPortsVTC = React.lazy(() => import("./pages/EgyptianPortsVTC.jsx"));
const EssentialclearancePage = React.lazy(() => import("./pages/EssentialclearancePage.jsx"));
const FarmsDirectoryPage = React.lazy(() => import("./pages/FarmsDirectoryPage.jsx"));
const FatteningLivestockPages = React.lazy(() => import("./pages/FatteningLivestockPages.jsx"));
const FeedMaterialPrices = React.lazy(() => import("./pages/FeedMaterialPrices.jsx"));
const FeedMillsDirectory = React.lazy(() => import("./pages/FeedMillsDirectory.jsx"));
const FinalGoodsPrices = React.lazy(() => import("./pages/FinalGoodsPrices.jsx"));
const FishFeedPage = React.lazy(() => import("./pages/FishFeedPage.jsx"));
const FishMarketPage = React.lazy(() => import("./pages/FishMarketPage.jsx"));
const GlobalNews = React.lazy(() => import("./pages/GlobalNews.jsx"));
const GovNews = React.lazy(() => import("./pages/GovNews.jsx"));
const GpsPage = React.lazy(() => import("./pages/GpsPage.jsx"));
const GreenTesch = React.lazy(() => import("./pages/GreenTesch.jsx"));
const Home = React.lazy(() => import("./pages/Home.jsx"));
const InterviewsReports = React.lazy(() => import("./pages/InterviewsReports.jsx"));
const Jobpages = React.lazy(() => import("./pages/Jobpages.jsx"));
const JoinCommodityPage = React.lazy(() => import("./pages/JoinCommodityPage.jsx"));
const LocalNews = React.lazy(() => import("./pages/LocalNews.jsx"));
const LoginPage = React.lazy(() => import("./pages/LoginPage.jsx"));
const Newspage = React.lazy(() => import("./pages/Newspage.jsx"));
const NotFoundPage = React.lazy(() => import("./pages/NotFoundPage.jsx"));
const OstrichPage = React.lazy(() => import("./pages/OstrichPage.jsx"));
const OstrichPricesPage = React.lazy(() => import("./pages/OstrichPricesPage.jsx"));
const PersonalProfile = React.lazy(() => import("./pages/PersonalProfile.jsx"));
const PodcastPage = React.lazy(() => import("./pages/PodcastPage.jsx"));
const PostsPage = React.lazy(() => import("./pages/PostsPage.jsx"));
const PoultryFeedpage = React.lazy(() => import("./pages/PoultryFeedpage.jsx"));
const PoultryFeedPrices = React.lazy(() => import("./pages/PoultryFeedPrices.jsx"));
const PoultrylivestockmarketsPage = React.lazy(() => import("./pages/PoultrylivestockmarketsPage.jsx"));
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy.jsx"));
const ProductAnimalpage = React.lazy(() => import("./pages/ProductAnimalpage.jsx"));
const ProductpricesPage = React.lazy(() => import("./pages/ProductpricesPage.jsx"));
const ProductStatistics = React.lazy(() => import("./pages/ProductStatistics.jsx"));
const SalaryCategoryPage = React.lazy(() => import("./pages/SalaryCategoryPage.jsx"));
const SearchPage = React.lazy(() => import("./pages/SearchPage.jsx"));
const ShipMovementPage = React.lazy(() => import("./pages/ShipMovementPage.jsx"));
const ShipTrafficEgypt = React.lazy(() => import("./pages/ShipTrafficEgypt.jsx"));
const SignUPPage = React.lazy(() => import("./pages/SignUPPage.jsx"));
const SingleGpsPage = React.lazy(() => import("./pages/SingleGpsPage.jsx"));
const SingleNews = React.lazy(() => import("./pages/SingleNews.jsx"));
const SingleVideo = React.lazy(() => import("./pages/SingleVideo.jsx"));
const TurkeyFeedPages = React.lazy(() => import("./pages/TurkeyFeedPages.jsx"));
const VetArticles = React.lazy(() => import("./pages/VetArticles.jsx"));
const VeterinaryJobspage = React.lazy(() => import("./pages/VeterinaryJobspage.jsx"));
const WebsiteMap = React.lazy(() => import("./pages/WebsiteMap.jsx"));
const WebsiteOverview = React.lazy(() => import("./pages/WebsiteOverview.jsx"));
const WriterPage = React.lazy(() => import("./pages/WriterPage.jsx"));
const ResetScroll = ({ children }) => {
  const location = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);

    const routeTitles = {
      "/": "الرئيسية",
      "/news": "الأخبار",
      "/global_news": "أخبار عالمية",
      "/local_news": "أخبار محلية",
      "/gov_news": "أخبار حكومية",
      "/agriculture_news": "أخبار زراعية",
      "/economic_news": "أخبار اقتصادية",
      "/green_tech": "التكنولوجيا الخضراء",
      "/between-people": "بين الناس",
      "/interview_report": "حوارات وتقارير",
      "/commodity": "البورصة السلعية",
      "/salary_category": "فئات المرتبات",
      "/product_price": "أسعار المنتجات",
      "/company_price": "أسعار الشركات",
      "/add-company": "إضافة شركة",
      "/join_commodity": "الانضمام للبورصة",
      "/banks": "البنوك",
      "/gps": "دليل الشركات",
      "/feedmill": "مصانع الأعلاف",
      "/farmsdirectory": "دليل المزارع",
      "/citie_governorates": "المدن والمحافظات",
      "/company_director": "دليل الشركات",
      "/podcast": "بودكاست",
      "/advertising_request": "طلب إعلان",
      "/contact_us": "اتصل بنا",
      "/about_Us": "من نحن",
      "/privacy_policy": "سياسة الخصوصية",
      "/website_map": "خريطة الموقع",
      "/personal_profile": "الملف الشخصي",
      "/animal_health": "صحة الحيوان",
      "/verterinary_jobs": "وظائف بيطرية",
      "/add_product": "إضافة منتج",
      "/create_job": "إنشاء وظيفة",
      "/ship_movement": "حركة السفن",
      "/ship_traffic_egypt": "حركة السفن في مصر",
      "/egyption_port_vtc": "الموانئ المصرية",
      "/feed_material_price": "أسعار خامات الأعلاف",
      "/final_good_price": "أسعار السلع النهائية",
      "/chick_companies": "شركات الكتاكيت",
      "/daily_egg": "أسعار البيض اليومية",
      "/daily_egg_distribut": "موزعي البيض",
      "/poultry_feed": "أعلاف الدواجن",
      "/poultry_price": "أسعار الدواجن",
      "/poultry_livestock": "أسواق الدواجن والمواشي",
      "/fattening_livestock": "تسمين المواشي",
      "/dairy_cow": "أبقار الحلاب",
      "/fish_feed": "أعلاف الأسماك",
      "/turkey_feed": "أعلاف الرومي",
      "/duck_feed": "أعلاف البط",
      "/ostrich_price": "أسعار النعام",
      "/fish_market": "سوق الأسماك",
      "/essential_clearance": "الإفراجات الأساسية",
      "/vetarticles": "مقالات بيطرية",
      "/poultry_farming": "تربية الدواجن",
      "/livestock_farming": "تربية المواشي",
      "/fish_farming": "الاستزراع السمكي",
      "/turkey_farming": "تربية الرومي",
      "/duck_farm": "تربية البط",
      "/other_farm": "تربيات أخرى",
      "/poultry_diseases": "أمراض الدواجن",
      "/lives_stockdisease": "أمراض المواشي",
      "/fish_diseases": "أمراض الأسماك",
      "/turkey_diseases": "أمراض الرومي",
      "/duck_diseases": "أمراض البط",
      "/other_diseases": "أمراض أخرى",
      "/website_overview": "نظرة عامة على الموقع",
      "/search_page": "البحث",
      "/addgps": "إضافة موقع",
      "/login_page": "تسجيل الدخول",
      "/sign_up": "إنشاء حساب",
      "/verify-otp": "تأكيد الرمز",
      "/ostrich_page": "النعام",
      "/auth/callback": "جاري التحقق"
    };

    const getPageName = (pathname) => {
      const normalizedPath = pathname === "/" ? "/" : pathname.replace(/\/$/, "");

      if (routeTitles[normalizedPath]) return routeTitles[normalizedPath];
      
      if (normalizedPath.startsWith("/single_news/")) return "تفاصيل الخبر";
      if (normalizedPath.startsWith("/product_static/")) return "إحصائيات المنتج";
      if (normalizedPath.startsWith("/single-gps/")) return "تفاصيل الموقع";
      if (normalizedPath.startsWith("/company_director/")) return "دليل الشركات";
      if (normalizedPath.startsWith("/single_video/")) return "فيديو";
      if (normalizedPath.startsWith("/post/")) return "مقال";
      if (normalizedPath.startsWith("/product/")) return "تفاصيل المنتج";
      if (normalizedPath.startsWith("/job_pages/")) return "تفاصيل الوظيفة";
      if (normalizedPath.startsWith("/apply_now/")) return "التقديم للوظيفة";
      if (normalizedPath.startsWith("/company_profile_traffic/")) return "ملف الشركة";
      if (normalizedPath.startsWith("/company_profile/")) return "ملف الشركة";
      if (normalizedPath.startsWith("/corn_shipment/")) return "شحنات الذرة";
      if (normalizedPath.startsWith("/corn_shipment-vtc/")) return "شحنات الذرة";
      if (normalizedPath.startsWith("/essential_clearance/")) return "الإفراجات الأساسية";
      if (normalizedPath.startsWith("/character/")) return "شخصية";
      if (normalizedPath.startsWith("/writer/")) return "الكاتب";
      if (normalizedPath.startsWith("/ostrich/")) return "النعام";

      return "";
    };

    const pageName = getPageName(location.pathname);
    if (pageName) {
      document.title = `${pageName} - قلم بيطري | Vet Pen`;
    } else {
      document.title = "قلم بيطري | Vet Pen";
    }
  }, [location]);
  return children;
};
const App = () => {
  const [showLoader, setShowLoader] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  if (showLoader) {
    return <Loader />;
  }
  return (
    <div className="App">
      <ResetScroll>
        <div id="popup-root"></div>
        <React.Suspense fallback={<Loader />}><Routes>
          <Route path="/" element={<Home />} />
          <Route path="news" element={<Newspage />} />
          <Route path="global_news" element={<GlobalNews />} />
          <Route path="local_news" element={<LocalNews />} />
          <Route path="gov_news" element={<GovNews />} />
          <Route path="agriculture_news" element={<AgricultureNews />} />
          <Route path="economic_news" element={<EconmicNews />} />
          <Route path="green_tech" element={<GreenTesch />} />
          <Route path="between-people" element={<BetweenPeople />} />
          <Route path="interview_report" element={<InterviewsReports />} />
          <Route path="/single_news/:slug" element={<SingleNews />} />
          <Route path="commodity" element={<CommodityExchangepage />} />
          <Route path="salary_category" element={<SalaryCategoryPage />} />
          <Route path="product_price" element={<ProductpricesPage />} />
          <Route path="company_price" element={<CompanyProductPrices />} />
          <Route path="add-company" element={<AddCompany />} />
          <Route path="product_static/:id" element={<ProductStatistics />} />
          <Route path="join_commodity" element={<JoinCommodityPage />} />
          <Route path="banks" element={<Banks />} />
          <Route path="gps" element={<GpsPage />} />
          <Route path="feedmill" element={<FeedMillsDirectory />} />
          <Route path="farmsdirectory" element={<FarmsDirectoryPage />} />
          <Route path="single-gps/:id" element={<SingleGpsPage />} />
          <Route path="citie_governorates" element={<CitiesGovernorates />} />
          <Route path="company_director" element={<CompanyDirectory />} />
          <Route path="company_director/:id" element={<CompanyDirectory />} />
          <Route path="podcast" element={<PodcastPage />} />
          <Route path="single_video/:slug" element={<SingleVideo />} />
          <Route path="advertising_request" element={<AdvertisingRequest />} />
          <Route path="contact_us" element={<ContactUs />} />
          <Route path="/post/:slug" element={<PostsPage />} />
          <Route path="about_Us" element={<AboutUsPage />} />
          <Route path="privacy_policy" element={<PrivacyPolicy />} />
          <Route path="website_map" element={<WebsiteMap />} />
          <Route path="personal_profile" element={<PersonalProfile />} />
          <Route path="animal_health" element={<AnimalHealthMarket />} />
          <Route path="product/:slug" element={<ProductAnimalpage />} />
          <Route path="verterinary_jobs" element={<VeterinaryJobspage />} />
          <Route path="job_pages/:slug" element={<Jobpages />} />
          <Route path="add_product" element={<AddProductPage />} />
          <Route path="/apply_now/:id" element={<ApplynowPage />} />
          <Route path="create_job" element={<CreateJobpage />} />
          <Route path="ship_movement" element={<ShipMovementPage />} />
          <Route path="ship_traffic_egypt" element={<ShipTrafficEgypt />} />
          <Route path="egyption_port_vtc" element={<EgyptianPortsVTC />} />
          <Route path="/company_profile_traffic/:id" element={<CompanyPage />} />
          <Route path="/company_profile/:slug" element={<CompanyGpsPage />} />
          <Route path="corn_shipment/:type" element={<CornshipmentsPage />} />
          <Route path="corn_shipment-vtc/:type" element={<CornshipmentsPage />} />
          <Route
            path="feed_material_price"
            element={
              <ProtectedRoute>
                <FeedMaterialPrices />
              </ProtectedRoute>
            }
          />
          <Route path="final_good_price" element={<FinalGoodsPrices />} />
          <Route path="chick_companies" element={<ChickCompaniesPage />} />
          <Route path="daily_egg" element={<DailyEggPricePage />} />
          <Route path="daily_egg_distribut" element={<DailyEggDistributorsPage />} />
          <Route path="poultry_feed" element={<PoultryFeedpage />} />
          <Route path="poultry_price" element={<PoultryFeedPrices />} />
          <Route path="poultry_livestock" element={<PoultrylivestockmarketsPage />} />
          <Route path="fattening_livestock" element={<FatteningLivestockPages />} />
          <Route path="dairy_cow" element={<DairyCowFeed />} />
          <Route path="fish_feed" element={<FishFeedPage />} />
          <Route path="turkey_feed" element={<TurkeyFeedPages />} />
          <Route path="duck_feed" element={<DuckFeedPage />} />
          <Route path="ostrich_price" element={<OstrichPricesPage />} />
          <Route path="fish_market" element={<FishMarketPage />} />
          <Route path="essential_clearance" element={<EssentialclearancePage />} />
          <Route path="essential_clearance/:type" element={<ClearanceShipmentsPage />} />
          <Route path="vetarticles" element={<VetArticles />} />
          <Route path="poultry_farming" element={<PoultryFarming />} />
          <Route path="livestock_farming" element={<AnimalFarming />} />
          <Route path="fish_farming" element={<FishFarming />} />
          <Route path="turkey_farming" element={<TurkeyFarming />} />
          <Route path="duck_farm" element={<DuckFarm />} />
          <Route path="other_farm" element={<OtherFarming />} />
          <Route path="poultry_diseases" element={<PoultryDiseases />} />
          <Route path="lives_stockdisease" element={<LivestockDiseases />} />
          <Route path="fish_diseases" element={<FishDiseases />} />
          <Route path="turkey_diseases" element={<TurkeyDiseases />} />
          <Route path="duck_diseases" element={<DuckDiseases />} />
          <Route path="other_diseases" element={<OtherBirdsDiseases />} />
          <Route path="website_overview" element={<WebsiteOverview />} />
          <Route path="search_page" element={<SearchPage />} />
          <Route path="addgps" element={<AddGps />} />
          <Route path="login_page" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="sign_up" element={<SignUPPage />} />
          <Route path="verify-otp" element={<VerifyOTP />} />
          <Route path="/character/:slug" element={<CharacterPage />} />
          <Route path="/writer/:slug" element={<WriterPage />} />
          <Route path="/ostrich_page" element={<OstrichPage />} />
          <Route path="/ostrich/:slug" element={<OstrichPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes></React.Suspense>
        <ToastContainer position="top-right" autoClose={3000} newestOnTop={true} closeOnClick pauseOnHover draggable />
      </ResetScroll>
    </div>
  );
};
export default App;
